var map = {
	"./Elektricitet-MedVind_colour.png": 86,
	"./cat.png": 233,
	"./fejring_farve.png": 234,
	"./hjælpeløs_farve.png": 145,
	"./ladeboks.svg": 235,
	"./norlys-blad-product.png": 236,
	"./norlys-og-standard.png": 237
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 232;